import type { DogId } from '../assets/names';
import type { Location } from '../core/level';

export interface DogInfo {
  id: DogId;
  name: string;
  breed: string;
  location: Location | 'tokyo';
  /** arrives after winning this level (or when its location unlocks) */
  arrivesAfterLevel: number | null;
  /** short personality lines, shown when the dog is tapped (in-game text: English) */
  lines: string[];
}

/**
 * The rescue dogs. Honey arrives after the first win, then one every
 * three levels; Coco comes with Paris, Kiko waits for Tokyo.
 */
export const DOGS: DogInfo[] = [
  { id: 'honey', name: 'Honey', breed: 'Golden Retriever', location: 'cafe', arrivesAfterLevel: 1,
    lines: ['Loves sunny windows and belly rubs.', 'Greets every guest at the door.', 'Thinks croissants are a food group.'] },
  { id: 'pretzel', name: 'Pretzel', breed: 'Dachshund', location: 'cafe', arrivesAfterLevel: 4,
    lines: ['Small legs, big opinions.', 'Can fit under any table.', 'Guards the pastry case. Very seriously.'] },
  { id: 'mochi', name: 'Mochi', breed: 'French Bulldog', location: 'cafe', arrivesAfterLevel: 7,
    lines: ['Snores like a tiny espresso machine.', 'Master of the afternoon nap.', 'Will trade kisses for cookies.'] },
  { id: 'biscuit', name: 'Biscuit', breed: 'Corgi', location: 'cafe', arrivesAfterLevel: 10,
    lines: ['Herds the chairs back into place.', 'Those ears hear the treat jar open.', 'Fluffy bottom, proud strut.'] },
  { id: 'muffin', name: 'Muffin', breed: 'Beagle', location: 'cafe', arrivesAfterLevel: 13,
    lines: ['Follows every smell in the kitchen.', 'Sings along to the coffee grinder.', 'Nose first, questions later.'] },
  { id: 'pepper', name: 'Pepper', breed: 'Mixed breed', location: 'cafe', arrivesAfterLevel: 16,
    lines: ['A little scruffy, a lot of heart.', 'Brave enough to meet every new dog.', 'Best friend of the whole café.'] },
  { id: 'coco', name: 'Coco', breed: 'Poodle', location: 'paris', arrivesAfterLevel: 18,
    lines: ['Bonjour! Loves long walks by the river.', 'Every curl in its perfect place.', 'Prefers her macarons pink.'] },
  { id: 'kiko', name: 'Kiko', breed: 'Shiba Inu', location: 'tokyo', arrivesAfterLevel: null,
    lines: ['Waiting for you in Tokyo.'] },
];

export const dogInfo = (id: DogId) => DOGS.find((d) => d.id === id)!;
